import _ from 'lodash'

export default {
    makeRequestConfig(parameters = {}) {
        let params = parameters;
        let headers = {};

        if (params.masterToken) {
            headers = _.assign({ Authorization: "Bearer " + params.masterToken }, headers)
            delete params.masterToken
        }

        if(params.token) {
            headers = _.assign({ Authorization: "Bearer " + params.token }, headers)
            delete params.token
        }

        return {
            params,
            headers
        }
    }
}